import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Esto es un tratamiento médico?',
  a: 'No. Es material educativo de hábitos, autocuidado, alimentación simple, registro del ciclo y regulación emocional. No reemplaza consulta médica, ginecológica, psicológica o nutricional.'
}, {
  q: '¿Me va a eliminar el dolor para siempre?',
  a: 'No. La guía está pensada para ayudarte a acompañar y reducir molestias comunes, no para prometer curas ni resultados médicos garantizados.'
}, {
  q: '¿Necesito comprar suplementos?',
  a: 'No. El kit fue creado justamente para ayudarte sin suplementos caros y sin dietas extremas.'
}, {
  q: '¿Tengo que usar Notion sí o sí?',
  a: 'No. El tracker está en Notion, pero podés copiar el sistema a papel, notas del celular o Google Sheets.'
}, {
  q: '¿Sirve si estoy en pareja y esos días sobrepienso todo?',
  a: 'Sí. De hecho, uno de los focos del kit es ayudarte a regular mejor tu parte emocional y relacional antes de reaccionar o discutir de más.'
}, {
  q: '¿Cuándo debería empezar a usarlo?',
  a: 'Idealmente, 5 días antes de que te venga. Pero también podés usar los bonus y la meditación durante el periodo.'
}, {
  q: '¿Esto me sirve si tengo dolor muy fuerte?',
  a: 'Puede ayudarte a acompañarte mejor, pero si el dolor es incapacitante o muy intenso, lo correcto es consultar con una profesional.'
}, {
  q: '¿Qué recibo después de comprar?',
  a: 'Acceso digital inmediato a: Guía 5x5 Ciclo en Calma, Bonus Recetas Rápidas 5+5, Tracker Notion 5x5, Meditación Volver a Mí, y Bonus Qué Hacer Durante el Periodo.'
}, {
  q: '¿La IA reemplaza una consulta médica?',
  a: 'No. La IA Ciclo en Calma es una herramienta educativa para ayudarte a aplicar la guía, organizar tus hábitos y resolver dudas prácticas sobre el método. No diagnostica, no trata enfermedades y no reemplaza atención médica, ginecológica, psicológica o nutricional.'
}, {
  q: '¿La puedo usar cuando quiera?',
  a: 'Sí. Vas a poder consultarle dudas sobre el método, tus síntomas comunes, recetas, descanso, movimiento, ansiedad, relación, trabajo o estudio durante tus días previos y durante el periodo.'
}, {
  q: '¿Necesito saber usar ChatGPT?',
  a: 'No. Te vamos a dejar instrucciones simples para acceder y empezar a preguntarle como si fuera una guía interactiva.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-cream px-4 sm:px-6 lg:px-8" data-id="element-58">
      <div className="max-w-3xl mx-auto" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-60">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark mb-4" data-id="element-61">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1 bg-burgundy mx-auto mt-6" data-id="element-62"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-63">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-64">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-65">
                <span className={`font-serif font-bold text-lg ${openIndex === index ? 'text-burgundy' : 'text-dark'}`} data-id="element-66">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${openIndex === index ? 'transform rotate-180 text-burgundy' : ''}`} data-id="element-67" />
              </button>
              <AnimatePresence data-id="element-68">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-69">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed border-t border-gray-50 pt-4" data-id="element-70">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}